import { defineStore } from 'pinia';

export interface dynamicObj {
  [key: string]: any;
}

export const useSystemsLogsStore = defineStore('systems_logs_store', {
  state: () => ({
    pagination_size_key: 'SYS_PAGINATION_SIZE',
    pagination_size: 5,
    paginationCount: 0,
    total_data: 0,
    order_by: {} as dynamicObj,
    pagination: {
      current_page: 1,
      total_pages: 0,
      page_size: 10,
    },
    params: {
      keyword: '',
      po_number: '',
      order_number: '',
      order_date: '',
      after_date: '',
      before_date: '',
      sort_by: '',
      order: '',
      order_status: '',
    },
  }),
  actions: {
    resetPagination() {
      this.pagination = {
        current_page: 1,
        total_pages: 0,
        page_size: 10,
      };
    },
  },
});
